import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'yfenAbove';
const args = {};

export class YfenAbove extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
